import { DynamicGalleryRepository, DynamicGalleryService } from '@aipb/gulliver/dynamic-gallery/data-access';
import { DynamicGalleryFeatureCollectionModule } from '@aipb/gulliver/dynamic-gallery/feature-collection';
import { DynamicGalleryFeatureRecordModule } from '@aipb/gulliver/dynamic-gallery/feature-record';
import { RecordViewMode } from '@aipb/gulliver/dynamic-gallery/model';
import { DynamicGalleryRouting } from '@aipb/gulliver/dynamic-gallery/routing';
import { FrameService } from '@aipb/gulliver/frame/data-access';
import { InsideLoadingComponent } from '@aipb/shared/ui/loading';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Fancybox } from '@fancyapps/ui';
import { RouterRepository } from '@ngneat/elf-ng-router-store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, mergeMap, tap } from 'rxjs';
import {
  ROUTE_CATEGORY_BREADCRUMB,
  ROUTE_CATEGORY_COLLECTION,
  ROUTE_CATEGORY_ROOT_COLLECTION
} from '../dynamic-gallery.constants';

const f = Fancybox;

@UntilDestroy()
@Component({
  selector: 'dg-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InsideLoadingComponent,
    DynamicGalleryFeatureCollectionModule,
    DynamicGalleryFeatureRecordModule
  ]
})
export class EntryComponent implements OnInit {
  private dynamicGalleryRepository = inject(DynamicGalleryRepository);
  breadcrumbs$ = this.dynamicGalleryRepository.breadcrumbs$;
  rootCollection$ = this.dynamicGalleryRepository.rootCollection$;
  rootCollections$ = this.dynamicGalleryRepository.rootCollections$;
  collections$ = this.dynamicGalleryRepository.collections$;
  collection$ = this.dynamicGalleryRepository.collection$;
  pagination$ = this.dynamicGalleryRepository.pagination$;
  records$ = this.dynamicGalleryRepository.records$;
  collectionLabel$ = this.dynamicGalleryRepository.collectionLabel$;
  loading$ = this.dynamicGalleryRepository.loading$;

  constructor(
    private routerRepository: RouterRepository,
    private frame: FrameService,
    private dynamicGalleryRouting: DynamicGalleryRouting,
    private dynamicGalleryService: DynamicGalleryService
  ) {}

  ngOnInit() {
    this.dynamicGalleryService
      .requestRootData()
      .pipe(
        tap((data) => {
          this.frame.setDynamicRoutes(
            data.collections.map((c) => ({
              label: c.label,
              url: this.dynamicGalleryRouting.defaultRouteUrl(),
              queryParams: {
                url: c.url
              },
              category: ROUTE_CATEGORY_ROOT_COLLECTION
            }))
          );
        }),
        untilDestroyed(this)
      )
      .subscribe();

    this.routerRepository
      .selectQueryParams()
      .pipe(
        tap((params) => {
          if (!('url' in params)) {
            this.dynamicGalleryRepository.reset();
          }

          if ('mode' in params) {
            this.dynamicGalleryRepository.setRecordViewMode(<RecordViewMode>params['mode']);
          }
        }),
        filter((params) => 'url' in params),
        mergeMap((params) => this.dynamicGalleryService.requestData(params['url'])),
        tap((data) => {
          this.frame.setDynamicRoutes([
            ...data.navigation.breadcrumbs.map((b) => ({
              label: b.label,
              url: this.dynamicGalleryRouting.defaultRouteUrl(),
              queryParams: {
                url: b.url
              },
              category: ROUTE_CATEGORY_BREADCRUMB,
              deletable: false
            })),
            ...(data.collections.length > 0
              ? data.collections.map((c) => ({
                  label: c.label,
                  url: this.dynamicGalleryRouting.defaultRouteUrl(),
                  queryParams: {
                    url: c.url
                  },
                  category: ROUTE_CATEGORY_COLLECTION
                }))
              : [])
          ]);
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
